import React, { useState } from "react";
import { api } from "../api";

export default function Admin() {
    const [username, setUsername] = useState("");
    const [password, setPassword] = useState("");
    const [busy, setBusy] = useState(false);
    const [err, setErr] = useState("");
    const [msg, setMsg] = useState("");

    async function onSubmit(e) {
        e.preventDefault();
        setErr("");
        setMsg("");
        setBusy(true);
        try {
            await api.usersCreate(username.trim(), password);
            setMsg("Uživatel vytvořen.");
            setUsername("");
            setPassword("");
        } catch (e2) {
            setErr(e2 && e2.message ? e2.message : "create_failed");
        } finally {
            setBusy(false);
        }
    }

    return (
        <section className="card overflow-hidden">
            <div className="cardHeader">
                <div className="text-text-100 font-extrabold text-2xl">Administrace</div>
                <div className="text-text-300 mt-2">Vytváření uživatelů</div>
            </div>

            <div className="cardBody">
                <form onSubmit={onSubmit} className="space-y-6">
                    <div className="grid grid-cols-1 xl:grid-cols-2 gap-6">
                        <div>
                            <div className="label">Username</div>
                            <input value={username} onChange={(e) => setUsername(e.target.value)} className="input mt-3" autoComplete="off" />
                        </div>

                        <div>
                            <div className="label">Dočasné heslo</div>
                            <input value={password} onChange={(e) => setPassword(e.target.value)} className="input mt-3" type="password" autoComplete="off" />
                        </div>
                    </div>

                    {err ? (
                        <div className="rounded-2xl border border-bad/35 bg-bad/10 p-4">
                            <div className="text-text-100 font-semibold">Nelze vytvořit</div>
                            <div className="text-text-200 text-sm mt-1">{err}</div>
                        </div>
                    ) : null}

                    {msg ? (
                        <div className="rounded-2xl border border-ok/35 bg-ok/10 p-4">
                            <div className="text-text-100 font-semibold">{msg}</div>
                        </div>
                    ) : null}

                    <button disabled={busy} className={busy ? "btnPrimary opacity-60 cursor-not-allowed" : "btnPrimary"}>
                        {busy ? "Vytvářím" : "Vytvořit uživatele"}
                    </button>
                </form>
            </div>
        </section>
    );
}
